import styled, { css } from "styled-components";

import { colors } from "../../styles";

const primaryColor = colors.darkBlue;

const Button = styled.button`
  display: inline-block;
  padding: 15px 25px;
  border: 0;
  border-radius: 10px;
  text-transform: uppercase;
  cursor: pointer;

  ${(props) =>
    css`
      border: ${props.disabled ? colors.gray : primaryColor} solid 2px;
    `}
  ${(props) =>
    props.$type === "primary" &&
    !props.disabled &&
    css`
      color: ${colors.white};
      background-color: ${primaryColor};
    `}
  ${(props) =>
    props.$type === "secondary" &&
    !props.disabled &&
    css`
      background-color: ${colors.white};
      color: ${primaryColor};
    `}
  ${(props) =>
    props.$type === "tertiary" &&
    !props.disabled &&
    css`
      background-color: transparent;
      color: ${primaryColor};
      border: 0;
    `}
  ${(props) =>
    props.$fluid &&
    css`
      width: 100%;
    `}
`;

Button.defaultProps = {
  $type: "primary",
  type: "button",
};

export default Button;
